<div class="container-info-pay">
    <div class="logo-city">
        <i class="fal fa-circle-info"></i>
    </div>
    <p class="info-confirm">Se ha producido un error al procesar el pago.</p>
</div>